import { Card, Text, Accordion, Group } from '@mantine/core';
import React from 'react';
import { theme } from '../consilitheme';

const SynthesisItem = ({ synthesis }) => {
  const datePattern = /\/(\d{4}-\d{2}-\d{2})\//;
  const match = synthesis.s3_path.match(datePattern);

  const dateString = match ? match[1] : synthesis.created;
  const dateObject = new Date(dateString);
  const formattedDate = [
    dateObject.toISOString().split('T')[0],
    dateObject.toLocaleTimeString('en-US', { hour12: true }),
  ];

  return (
    <Card shadow="md" radius="md" withBorder style={{ cursor: 'pointer' }}>
      <Accordion.Control
        style={{
          backgroundColor: 'transparent',
          outlineColor: 'transparent',
          width: '101%',
        }}
      >
        <Group justify="space-between">
          <Text
            size="md"
            fw={600}
            style={{ marginBottom: '0.5rem', width: '80%' }}
          >
            {synthesis.title ?? 'No title available'}
          </Text>
          <Text
            size="sm"
            c={theme.colors.gray[3]}
            mr={'16px'}
            pos="absolute"
            right={28}
            top={28}
          >
            {formattedDate[0]}
          </Text>
          <Text
            size="sm"
            c={theme.colors.gray[3]}
            mr={'16px'}
            pos="absolute"
            right={28}
            top={44}
          >
            {formattedDate[1]}
          </Text>
        </Group>
        <Accordion.Panel ml={-16}>
          <Text fw={300} pl={0} style={{ whiteSpace: 'pre-line' }}>
            {synthesis.summary ?? 'No summary available'}
          </Text>
        </Accordion.Panel>
      </Accordion.Control>
    </Card>
  );
};

export default SynthesisItem;
